var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.212,
    height: 35.086,
    viewBox: "0 0 35.212 35.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7927",
    d: "M8.515 44.351a.621.621 0 1 0-1.088.6c6.466 11.925 24 11.922 30.466 0a.621.621 0 0 0-1.088-.6 16.151 16.151 0 0 1-28.291 0z",
    transform: "translate(-5.054 -19.008)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7928",
    d: "M36.11 10.907a.621.621 0 1 0 .944-.807c-6.645-8.045-19.741-8.044-26.385 0a.621.621 0 1 0 .945.807 16.193 16.193 0 0 1 24.496 0z",
    transform: "translate(-6.256 -3.867)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7929",
    d: "M18.771 12.688a.621.621 0 1 0 .741 1 12.438 12.438 0 0 1 14.762 0 .621.621 0 1 0 .741-1 13.683 13.683 0 0 0-16.244 0z",
    transform: "translate(-9.287 -6.121)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7930",
    d: "M25.388 50.222a13.584 13.584 0 0 0 10.7-5.185.621.621 0 1 0-.974-.772 12.447 12.447 0 0 1-19.461 0 .621.621 0 1 0-.974.772 13.584 13.584 0 0 0 10.7 5.185z",
    transform: "translate(-7.782 -19.008)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7931",
    d: "M4.336 28.277a2.739 2.739 0 0 0 2.392 4.015h6.912a3.12 3.12 0 0 0 3.1 3.138h9.311a3.107 3.107 0 0 0 3.1-3.138h6.919a2.739 2.739 0 0 0 2.392-4.015 7.172 7.172 0 0 0-3.943-3.363 3.9 3.9 0 1 0-4.765 0 7.157 7.157 0 0 0-3.679 2.937 8.37 8.37 0 0 0-2.084-1.013 4.5 4.5 0 1 0-5.186 0 8.37 8.37 0 0 0-2.085 1.014 7.184 7.184 0 0 0-3.679-2.937 3.9 3.9 0 1 0-4.764 0 7.172 7.172 0 0 0-3.943 3.363zm25.144-6.444a2.658 2.658 0 1 1 2.658 2.658 2.658 2.658 0 0 1-2.658-2.658zm2.653 3.9a5.934 5.934 0 0 1 5.235 3.132 1.489 1.489 0 0 1-1.3 2.184h-7.185a7.97 7.97 0 0 0-1.825-2.43 5.941 5.941 0 0 1 5.075-2.887zm-13.994-2.57a3.261 3.261 0 0 1 6.521 0 3.261 3.261 0 0 1-6.522 0zm9.555 8.267a1.879 1.879 0 0 1-1.639 2.757h-9.311A1.868 1.868 0 0 1 15.1 31.43a7.17 7.17 0 0 1 12.589 0zM8 21.833a2.658 2.658 0 1 1 2.658 2.658A2.658 2.658 0 0 1 8 21.833zm2.652 3.9a5.95 5.95 0 0 1 5.088 2.887 7.971 7.971 0 0 0-1.825 2.429H6.728a1.489 1.489 0 0 1-1.3-2.184 5.934 5.934 0 0 1 5.225-3.132z",
    transform: "translate(-3.793 -9.132)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".4px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderGroup);
export default __webpack_public_path__ + "static/media/order_group.1d80206924b794c17c5d161440042358.svg";
export { ForwardRef as ReactComponent };